import React from 'react';
import { Routes as DOMRoutes, Route, Navigate } from 'react-router-dom';
import MainLayout from '@/layout/MainLayout';
import AuthLayout from '@/layout/AuthLayout';
import { Toaster } from '@/components/ui/toaster';
import Loader from '@/components/Loader';
import { useRefreshToken } from '@/hooks/queries/auth/useRefreshToken';
import AuthPage from '@/pages/Auth';
import { useAppSelector } from '@/store/hooks';
import { selectAuth } from '@/store/selectors';
import { appRoutes, routePermissions } from '@/routes/config';
import { getRoutesForRole } from '@/routes/access';

export const Routes = () => {
  const { isLoading } = useRefreshToken();
  const { isAuthenticated, userData } = useAppSelector(selectAuth);

  // Foydalanuvchi roliga asoslangan sahifalarni filtrlash
  const filteredRoutes = getRoutesForRole(appRoutes, routePermissions, userData?.role);

  if (isLoading) {
    return (
      <>
        <Loader />
        <Toaster />
      </>
    );
  }

  return (
    <>
      {isAuthenticated ? (
        <MainLayout>
          <DOMRoutes>
            {filteredRoutes.map((route) => (
              <Route path={route.path} element={route.element} key={route.path} />
            ))}
            {/* Agar foydalanuvchi ruxsat berilmagan sahifaga kirmoqchi bo'lsa, bosh sahifaga yo'naltirish */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </DOMRoutes>
        </MainLayout>
      ) : (
        <AuthLayout>
          <DOMRoutes>
            <Route path="/" element={<AuthPage />} />
            <Route path="*" element={<AuthPage />} />
          </DOMRoutes>
        </AuthLayout>
      )}
      <Toaster />
    </>
  );
};
